/**
 * Public backend base URL from build-time env. Use `${API_BASE_URL}/api/...` for API calls.
 * Value comes only from process.env.REACT_APP_API_URL (trimmed, no trailing slash).
 * There is no code fallback to localhost; npm start uses env-cmd so .env files override shell vars.
 * Never put OpenAI keys, Firebase service accounts, or payment secrets here.
 */

const raw = process.env.REACT_APP_API_URL;
const normalized =
  typeof raw === 'string' && raw.trim() !== ''
    ? raw.trim().replace(/\/+$/, '')
    : '';

function parseAbsoluteUrl(urlString) {
  try {
    const u = new URL(urlString);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
    return u;
  } catch {
    return null;
  }
}

let trimmed = normalized;
const parsed = trimmed ? parseAbsoluteUrl(trimmed) : null;

if (trimmed && !parsed) {
  console.error(
    '[MyRoomsAI] REACT_APP_API_URL is not a valid http(s) URL:',
    normalized
  );
  trimmed = '';
} else if (parsed) {
  const port = parsed.port || (parsed.protocol === 'https:' ? '443' : '80');
  const isLocal =
    parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1';
  if (isLocal && port === '4000') {
    console.error(
      '[MyRoomsAI] REACT_APP_API_URL points at localhost:4000 (typical local Node PORT). ' +
        'The deployed Cloud Run backend will NOT be used; ensure your local server is running. ' +
        'For normal testing against production, set REACT_APP_API_URL to your HTTPS Cloud Run origin in ui/.env (and restart with npm start). ' +
        'If a shell or user env still forces localhost:4000, npm start runs via env-cmd so ui/.env overrides it.'
    );
  }
} else if (!normalized) {
  console.error(
    '[MyRoomsAI] REACT_APP_API_URL is missing. The frontend cannot reach the deployed backend. ' +
      'Add to ui/.env:\n' +
      'REACT_APP_API_URL=https://myroomsai-backend-687163206284.us-central1.run.app\n' +
      'Then run: npm start'
  );
}

export const HAS_API_URL = Boolean(trimmed);

/** Base origin for all `/api/*` requests (no trailing slash). */
export const API_BASE_URL = trimmed;

/** @deprecated Use API_BASE_URL */
export const API_URL = API_BASE_URL;
